/**
 * Accessibilité des formulaires Gravity Forms (soumission AJAX).
 *
 * RGAA 7.5 — Les messages de statut doivent être restitués par les technologies
 * d'assistance :
 *  - pendant l'envoi, le spinner visuel (.gform-loader) est doublé d'une annonce
 *    dans une région live ;
 *  - à réception de la confirmation AJAX, le focus est déplacé sur le message de
 *    succès pour qu'il soit annoncé et atteignable au clavier.
 *
 * RGAA 11.13 — La finalité des champs de saisie est renseignée via l'attribut
 * `autocomplete` (email, téléphone, nom/prénom) pour faciliter le remplissage auto.
 */
export default class GravityFormsA11y {
	constructor() {
		this.forms = document.querySelectorAll('form[id^="gform_"]');
		if (!this.forms.length) {
			return;
		}

		this.sendingLabel = window.mcArgs?.i18n?.formSending || "Envoi du formulaire en cours…";
		this.liveRegion = this.createLiveRegion();
		this.bindSubmit();
		this.bindConfirmation();
		this.forms.forEach((form) => this.setAutocomplete(form));
	}

	setAutocomplete(form) {
		// Ajoute l'attribut autocomplete quand il est absent, selon le type de champ.
		const map = [
			['input[type="email"]', "email"],
			['input[type="tel"]', "tel"],
			[".name_first input", "given-name"],
			[".name_last input", "family-name"],
		];

		map.forEach(([selector, token]) => {
			form.querySelectorAll(selector).forEach((input) => {
				if (!input.hasAttribute("autocomplete")) {
					input.setAttribute("autocomplete", token);
				}
			});
		});
	}

	createLiveRegion() {
		const region = document.createElement("p");
		region.className = "visually-hidden";
		region.setAttribute("role", "status");
		region.setAttribute("aria-live", "polite");
		document.body.appendChild(region);
		return region;
	}

	announce(message) {
		// On vide puis réécrit au frame suivant pour forcer la relecture par les AT.
		this.liveRegion.textContent = "";
		window.requestAnimationFrame(() => {
			this.liveRegion.textContent = message;
		});
	}

	bindSubmit() {
		this.forms.forEach((form) => {
			form.addEventListener("submit", () => this.announce(this.sendingLabel));
		});
	}

	bindConfirmation() {
		const $ = window.jQuery;
		if (!$) {
			return;
		}

		$(document).on("gform_confirmation_loaded", (event, formId) => {
			const wrapper =
				document.querySelector("#gform_confirmation_wrapper_" + formId) ||
				document.querySelector("#gforms_confirmation_message_" + formId) ||
				document.querySelector(".gform_confirmation_message");

			if (!wrapper) {
				return;
			}

			wrapper.setAttribute("tabindex", "-1");
			wrapper.focus();
		});

		// Le formulaire est recréé après une validation AJAX : on réapplique autocomplete.
		$(document).on("gform_post_render", (event, formId) => {
			const form = document.querySelector("#gform_" + formId);
			if (form) {
				this.setAutocomplete(form);
			}
		});
	}
}
